/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams, Link } from 'react-router-dom'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import EditIcon from '@mui/icons-material/Edit'
// import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { ExpandMore } from '../../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'
import { positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { standardButton } from '../../../../helpers/buttons'
import { dummyBox, capitalizeFirstLetter } from '../../../../helpers/globalHelpers'
import { returnVideoThumbnailFromLiveURL, returnDurationFromLiveURL } from '../../../../helpers/imageHandling'
import { profileCardImage } from '../../../../helpers/commonJSX'
import { handleSetVideoThumbnailDatingProfile } from '../../../../helpers/commonMethods'

import profPicDefault from '../../../../assets/seed-profpic-default-2.jpg'

const ProfileToReviewItem = (props) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Destructure Props
  const { profile, user } = props
  // console.log('profile ->', profile)

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  // const { userId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Tracks whether the card is expanded
  const [expanded, setExpanded] = useState(false)

  // Changes the card expanded state
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  // Video Handling
  const [videoDuration, setVideoDuration] = useState(-1)
  const [videoThumbnail, setVideoThumbnail] = useState('')

  useEffect(() => {
    // console.log('SelectMediaInstanceCard useEffect runs')
    // console.log('mediaItem ->', mediaItem)
    const getData = async () => {
      await handleSetVideoThumbnailDatingProfile(profile, 0, setVideoThumbnail, setVideoDuration)
    }

    if ('media' in profile && profile.media.length > 0 && profile.media[0].mediaType === 'video') {
      getData()
    }

  }, [])

  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('videoThumbnail ->', videoThumbnail)

  }, [videoThumbnail])


  return (
    <Card 
      align="left" 
      sx={{ 
        mt: 2,
        backgroundColor: 'white',
        // width: width < positionChangeWidthSm ? '80%' : '95%', 
        width: '95%',
        // maxWidth: '400px',
        // boxShadow: 3, 
        borderRadius: 3,
        border: 2,
        borderColor: 'black',
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
      }}
    >
      {/* Displays as a column on mobile and row on desktop */}
      <Box
        sx={{
          width: '100%',
          // display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'flex-start' : 'space-between', alignItems: 'center',
          display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            // height: width < positionChangeWidthSm ? '300px' : '200px',
            width: '100%',
            display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'center' : 'flex-start', alignItems: width < positionChangeWidthSm ? 'center' : 'center',
          }}
        >

          {/* {console.log('media url ->', profile.media)} */}
          {/* Image */}
          {profileCardImage(profile, videoThumbnail, profPicDefault, width, 'profileToReview')}

          {/* Type and Vibe, Completed, Feedback Drafts */}
          <Box
            sx={{
              // backgroundColor: 'yellow',
              ml: width < positionChangeWidthSm ? 0 : 1,
              mb: width < positionChangeWidthSm ? 2 : 0,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center',
            }}
          >
            {/* Name, Profile Type, and Vibe */}
            {/* Name */}
            <Typography
              textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
              sx={{
                // backgroundColor: 'yellow',
                // mt: width < positionChangeWidthSm ? 0 : 1,
                mb: width < positionChangeWidthSm ? 0 : 1,
                width: '95%',
                fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {`${capitalizeFirstLetter(profile.bio.vitalInfo.firstName)}, ${profile.bio.vitalInfo.age}, ${profile.bio.vitalInfo.gender}, ${profile.bio.vitalInfo.sexuality}`}
            </Typography>

            {/* Type */}
            <Typography
              textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
              sx={{
                // backgroundColor: 'yellow',
                // mt: width < positionChangeWidthSm ? 0 : 1,
                mb: width < positionChangeWidthSm ? 0 : 1,
                width: '95%',
                fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                // fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
              }}
            >
              Type: <span style={{ fontWeight: 'bold' }}>{capitalizeFirstLetter(profile.type)}</span>
            </Typography>

          </Box>

        </Box>
      </Box>
      
    </Card>
  )
}

export default ProfileToReviewItem